import { setSessionStore, curHouseInfo_key, isShowHouse_key } from '@/utils/localCache';

export default {
    updateCurHouseInfo: (state, seleHouseInfo) => {
        setSessionStore(curHouseInfo_key, seleHouseInfo);
        state.curHouseInfo = seleHouseInfo;
    },
    updateIsShowHouse: (state, isShowHouse) => {
        setSessionStore(isShowHouse_key, isShowHouse);
        state.isShowHouse = isShowHouse;
    },
}



// WEBPACK FOOTER //
// ./src/store/mutations.js